import React from 'react';
const points = [{
  emoji: '😰',
  title: 'Losing Confidence',
  text: "You arrive at class without knowing exactly what you're going to teach."
}, {
  emoji: '⏱️',
  title: 'Planning Burnout',
  text: 'You spend hours planning what could be solved in minutes.'
}, {
  emoji: '🤷',
  title: 'Philosophical Gap',
  text: "You don't know how to integrate yoga philosophy without sounding forced."
}, {
  emoji: '💸',
  title: 'Undervalued',
  text: 'You charge less than you deserve because you lack professional positioning.'
}, {
  emoji: '😓',
  title: 'Student Stagnation',
  text: "Your classes feel repetitive and your community isn't growing."
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <div className="text-center mb-12" data-id="element-96">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-97">
            👉 Do you recognize yourself in these scenes?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-98">
            If you answer "YES" to any of these — this bundle was made for you.
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-99">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-100">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-101">
                {point.emoji}
              </div>
              <p className="text-text-main text-base sm:text-lg leading-snug" data-id="element-102">
                <span className="font-bold" data-id="element-103">{point.title}:</span>{' '}
                <span className="font-medium" data-id="element-104">{point.text}</span>
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-105">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-106">
            You deserve more than that →
          </p>
        </div>
      </div>
    </section>;
}